module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-offline/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Railton Santos - Portfolio","short_name":"Rai","start_url":"/","background_color":"#fff","theme_color":"#005A5E","display":"standalone","icon":"src/images/rai-logo.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"16a9ed57f9b51fc0e9a2631c2a777f41"},
    }]
